import { App, Component, mount, xml, whenReady } from "@odoo/owl";

//import Counter from "./static/components/counter/counter";
import {WPCPortalRootHomeComponent} from  "@wpc_portal/pages/home/home";
import {WPCPortalRootPortalComponent} from  "@wpc_portal/pages/portal/portal";

import { templates } from "@dist/templates.js";
console.log('TEMPLATES', templates);


class Home extends Component {
    static template = xml`<WPCPortalRootHomeComponent/>`
    static components = {
        WPCPortalRootHomeComponent,
    };
}

class Portal extends Component {
    static template = xml`<WPCPortalRootPortalComponent/>`
    static components = {
        WPCPortalRootPortalComponent,
    };
}

async function start() {
    await whenReady();
    let comp;
    if ($("#home").length){
        console.log("##### HOME");
        comp = Home;
    }
    else{
        console.log("##### PORTAL");
        comp = Portal;
    }
    const rootApp = new App(comp, { name: "WPC" });

    Object.values(templates).map(x=>{
        rootApp.addTemplates(x);
    })

    await rootApp.mount(document.body);
}

start();
